var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
var specialCharacter = /[!@#$%^&*()_+\=\[\]{};':"\\|,<>\/?.]+/;
var specialCharacterwithoutPeriod = /[!@#$%^&*()_+\=\[\]{};':"\\|,<>\/?]+/;

export const status = {
  S01 : 'S01', // sucessfull transaction/s
  ER4 : 'ER4', // no results founds
  ER6 : 'ER6' // account locked
}

export function isUsername(str) {
  return !(str == undefined || str.length < 5 || str.length > 32);
}

export function isPassword(str) {
  return !(str == undefined || str.length < 6 || str.length > 32);
}

export function isConfirmPassword(pass1, pass2) {
  return (pass1 == pass2);
}

export function isFirstName(str) {
  return !(str == undefined || str.length < 1 || str.length > 50);
}

export function isLastName(str) {
  return !(str == undefined || str.length < 1 || str.length > 20);
}

export function isEmail (email) {
  return (email == "")? "" : (reg.test(email)) ? true : false;
}
// @deprecated
export function isNullOrEmpty(str) {
  return !(str == undefined || str.length < 1);
}

export function hasSpecialCharacter(str) {
  return specialCharacter.test(str);
}

export function hasNumber(str) {
  return /\d/.test(str);
}

export function pureSpace(str) {
  return /\S/.test(str);
}

export function isOrganization(str) {
  return !(str == undefined || str.length < 6 || str.length > 124);
}

export function isPhone(str) {
  return !(str == undefined || str.length < 9 || str.length > 20);
}

export function isIPAddress(str) {
  return !(str == undefined || str.length < 10 || str.length > 15);
}

export function isCode(str) {
  return !(str == undefined || str.length !=  6);
}

export function camelCase(str) {
  if((str===null) || (str==='')){
    return "";
  }else{
    str = str.toString();
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }
}

export function spaceBeforeText(str) {
  return (str.charAt(0) == " ");
}

export function hasSpecialCharacterExceptPeriod(str) {
  return specialCharacterwithoutPeriod.test(str);
}

export function checkifHasComAndNet(str) {
  return (str.endsWith(".com") || str.endsWith(".net"));
}

export function spacebetweenText(str) {
  return str.match(/\s/g);
}

export function setLoggedIn(bol){
  var Auth = {
    loggedIn: bol
  };
  console.log(Auth)
  localStorage.setItem('auth', JSON.stringify(Auth))
}

export function getLoggedIn(){
  var Auth = localStorage.getItem('auth');
  if(Auth){
    console.log(Auth)
    Auth = JSON.parse(Auth);
    return Auth.loggedIn;
  }
  return false
}

export function generate() {
  let CharacterSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let password = '';
  for(let i=0; i < 8; i++) {
    password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
  }
  return password;
}